import React, { useState } from "react";

import "./styles.less";
import { useTranslation } from "react-i18next";

export const AboutusBanner = () => {
  const { t } = useTranslation();

  return (
    <div>
      <section>
        <div className="aboutus-banner-warp">
          <div className="inner">
            <div className="aboutus-banner">
              <div className="aboutus-banner-text">
                <h3 className="title">
                  <div>{t("aboutus.banner.title1")}</div>
                  <div className="num">40,000,000</div>
                  <div>{t("aboutus.banner.title2")}</div>
                </h3>
                <div className="subtitle">{t("aboutus.banner.subtitle")}</div>
              </div>
            </div>
            <div className="aboutus-intro">
              <div className="aboutus-intro-text">
                <div className="aboutus-intro-text-title">
                  {t("aboutus.banner.intro.title")}
                </div>
                <div className="aboutus-intro-text-subtitle">
                  {t("aboutus.banner.intro.descript")}
                </div>
              </div>
              <div className="aboutus-intro-img">
                <img
                  src="//files.authing.co/authing-website/aboutus-banner-img.png"
                  alt="Authing身份云"
                />
              </div>
            </div>
            <div className="aboutus-honner">
              <div className="aboutus-honner-item">
                <div className="card-icon">
                  <i className="icon authing-icon authing-question-answer-fill"></i>
                </div>
                <div className="text">
                  {t("aboutus.banner.intro.descript1")}
                </div>
              </div>
              <div className="aboutus-honner-item">
                <div className="card-icon">
                  <i className="icon authing-icon authing-bookmark-3-fill"></i>
                </div>
                <div className="text">
                  {t("aboutus.banner.intro.descript2")}
                </div>
              </div>
              <div className="aboutus-honner-item">
                <div className="card-icon">
                  <i className="icon authing-icon authing-service-fill"></i>
                </div>
                <div className="text">
                  {t("aboutus.banner.intro.descript3")}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
